<template>
  <div>
    <van-list
        class="list"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
      <div v-for="(item, index) in list" :key="index" class="Item" @click="toChat(item.roomId)"
           @touchstart="startLongPress($event,index,item.roomId,item.isTop)"
           @touchend="endLongPress"
           @mouseup="endLongPress">
        <div style="position: relative;">
          <img :src="item.roleInfo.avatarUrl" class="avatar"/>
          <div v-if="item.activeStatus===1" class="activeStatus"></div>
        </div>
        <div class="info">
          <div class="line">
            <div class="name">{{ item.roleInfo.roleName }}</div>
            <div class="orderStatus" v-if="item.orderStatus" :style="'background: ' + color[item.orderStatus]">{{ getOrderStatus(item.orderStatus) }}</div>
            <div class="time">{{ time(item.activeTime) }}</div>
          </div>
          <div class="line-2">
            <div class="message">{{ item.text }}</div>
            <div class="notice" style="margin-left: auto;" v-if="item.unreadCount">{{ item.unreadCount }}</div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>

import {Dialog, List, Toast} from "vant";
import Vue from "vue";

Vue.use(Dialog)
    .use(List)

import {getRoomList,updateTop} from "@/api/clerk/chat-room";
import {getSocketInstance, closeReconnect, closeWebSocket,clearChatData,roomSort} from "@/api/clerk/chat-websocket";

export default {
  name: "roomList",
  components: {},
  computed: {
    time: () => {
      return (val) => {
        let now = new Date()
        let nowYear = now.getFullYear()
        let nowMonth = now.getMonth() < 9 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
        let nowDay = now.getDate() < 10 ? "0" + now.getDate() : now.getDate();
        let dateStr = `${nowYear}-${nowMonth}-${nowDay}`
        let todayDateTime = new Date(dateStr).getTime()
        let yesterday = todayDateTime - (24 * 60 * 60 * 1000)
        let beforeDay = todayDateTime - (48 * 60 * 60 * 1000)
        if (val > todayDateTime) { //当天
          let date = new Date(val);
          let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
          let minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
          return hour + ':' + minute
        } else if (val < todayDateTime && val > yesterday) {
          return '昨天'
        } else if (val < yesterday && val > beforeDay) {
          return '前天'
        } else { //更早之前
          let date = new Date(val);
          let year = date.getFullYear();
          let month = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
          let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
          if (year == nowYear) {
            return month + '月' + day + '日'
          } else {
            return year + '年' + month + '月' + day + '日'
          }
        }
      }
    }
  },

  data() {
    return {
      pageSize: 15,
      cursor: null,
      loading: false,
      finished: false,
      list: [],
      roomRoleInfoMap: new Map(),
      timer: null,
      color: ['#FE9E65','#0CD7D5','#78A6FC']
    }
  },

  methods: {
    // 修改置顶
    updateTapEvent(index, roomId, isTop) {
      isTop = !isTop
      console.log(isTop)
      let title = isTop ? '确定要置顶该聊天吗？' : '确定要取消置顶该聊天吗？';
      Dialog.confirm({
        title: title,
      }).then(() => {
        Toast.loading({mask: true, message: "请稍候...",});
        updateTop(roomId, isTop).then((res) => {
          Toast.clear();
          const data = res.data;
          if (data.code == 0) {
            this.model = null;
            // this.updateTapSort(index, isTop);
            this.onLoad(true);
          } else {
            Dialog.alert({
              title: "修改失败",
              message: data.msg,
            });
          }
        });
      });
    },
    updateTapSort(index, isTop) {
      this.list[index].isTop = isTop
      this.list.sort((a, b) => {
        // 首先按照 isTop 进行排序，isTop 为 true 的排在前面
        if (a.isTop && !b.isTop) return -1;
        if (!a.isTop && b.isTop) return 1;

        // 如果 isTop 相同，则按照 activeTime 进行排序
        return b.activeTime - a.activeTime;
      });
      this.$store.commit('chat/setRoomData', this.list)
      roomSort();
    },

    startLongPress(event,index, roomId, isTop) {
      this.timer = setTimeout(() => {
          this.updateTapEvent(index, roomId, isTop)
      }, 800); // 长按时间为1秒钟
    },
    endLongPress() {
      clearTimeout(this.timer); // 清除定时器
    },
    toChat(roomId) {
      this.$router.push({
        path: '/clerk/chat/roomInfo',
        query: {
          id: roomId,
        }
      })
    },
    getOrderStatus(status){
      switch (status){
        case 0: return "待接单";
        case 1: return "待服务";
        case 2: return "服务中";
        case 3: return "已完成";
        case 4: return "已取消";
        default :
          return "";
      }
    },
    //转换成map
    async convertObjToMap(obj) {
      const map = this.roomRoleInfoMap;
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          map.set(key, obj[key]);
        }
      }
      // this.$store.state.roomRoleInfoMap = map
      this.$store.commit('chat/setRoomRoleInfoMap',map)
    },
    saveGlobal() {//保存会话记录到全局数据中
      this.$store.commit('chat/setRoomData',this.list)
      this.$store.commit('chat/setRoomRoleInfoList',this.list.map(a => a.roleInfo))
    },
    onLoad(resetFirstPage) {
      // 重置为首页
      if (resetFirstPage) {
        this.cursor = null
        this.positionType = false
        this.list = [];
      } else {
        this.positionType = true
      }
      this.loading = true
      getRoomList({
        cursor: this.cursor,
        pageSize: this.pageSize,
      }).then(res => {
        this.loading = false
        const data = res.data;
        if (data.code == 0) {
          this.list = this.list.concat(data.cursorPage.list)
          this.convertObjToMap(data.roleInfoMap)
          this.cursor = data.cursorPage.cursor
          if (data.cursorPage.isLast) {//是否是最后一页
            this.finished = true
          } else {
            this.finished = false
          }
          //将数据保存到全局
          this.saveGlobal()
        } else {
          this.finished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      }).catch(res =>{
        this.finished = true
        Dialog.alert({
          title: '加载失败',
        })
      })
    },
  },
  /**
   * 不在/chat路径下关闭通话
   */
  beforeRouteLeave(to, from, next) {
    if (!to.fullPath.includes("/chat")) {
      clearChatData(this.$store)
      closeReconnect()
      closeWebSocket()
    }
    next();
  },
  activated() {
    if (this.$hasFeature('chat')) {
      getSocketInstance(this.$store)
    }
  },
  mounted() {
    this.onLoad(true)
  },
}


</script>

<style scoped lang="less">
.list {

  .Item {
    display: flex;
    align-items: center;
    padding: 4vw 5.07vw;

    .avatar {

      width: 13.9vw;
      height: 13.9vw;
      border-radius: 50%;
    }
    .activeStatus{
      position: absolute;
      width: 2.4vw;
      height: 2.4vw;
      background: #24E877;
      border-radius: 50%;
      bottom: 0.5vw;
      right: 0.9vw;
      border: 0.4vw solid #FFFFFF;
    }

    .info {
      flex: 1;
      margin-left: 4.83vw;

      .line {
        display: flex;
        align-items: center;
        margin-bottom: 1.81vw;

        .name {
          font-size: 4vw;
          font-weight: bold;
          margin-right: 2.17vw;
        }

        .orderStatus {
          width: 9.9vw;
          height: 4.2vw;
          line-height: 4.2vw;
          background-color: #B687FC;
          border-radius: 1vw;
          color: #ffffff;
          font-size: 2.7vw;
          text-align: center;
        }

        .time {
          margin-left: auto;
          font-size: 3.2vw;
          color: #8C8C8C ;
        }
      }

      .line-2 {
        display: flex;
        align-items: center;
        .notice {
          border-radius: 222px;
          min-width: 3.6vw;
          height: 5.6vw;
          padding: 0 1vw;
          line-height: 5.6vw;
          text-align: center;
          color: #fff;
          font-size: 3.4vw;
          background: #FF6064;
        }
        .message {
          color: #8C8C8C;
          font-size: 3.38vw;
          overflow:hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
</style>
